<app-user-avatar
  class="avatar"
  [size]="40"
  [contact]="{ name: message()?.from?.name, email: message()?.from?.address }"
  [usePopover]="false"
  [appParticipantContextMenu]="fromParticipant()"
  [appParticipantContextMenuTenantItems]="[message()]"
  [appParticipantContextMenuShowContactOptions]="true"
  (click)="openSenderContactInDp()"
/>

<div class="info">
  <div
    class="info-name"
    [appParticipantContextMenu]="fromParticipant()"
  [appParticipantContextMenuTenantItems]="[message()]"
    [appParticipantContextMenuShowContactOptions]="true"
  >
    {{ fromParticipant() | formatParticipant }}
    @if (fromParticipant()?.vip) {
      <mat-icon
        svgIcon="crown"
        class="info-name-vip"
      />
    }
  </div>

  @if (message()?.to?.length) {
    <app-contacts-inline-list
      label="To:"
      [tenantItems]="[message()]"
      [contacts]="message()?.to"
    />
  }

  @if (message()?.cc?.length) {
    <app-contacts-inline-list
      label="CC:"
      [tenantItems]="[message()]"
      [contacts]="message()?.cc"
    />
  }

  @if (message()?.bcc?.length) {
    <app-contacts-inline-list
      label="BCC:"
      [tenantItems]="[message()]"
      [contacts]="message()?.bcc"
    />
  }
</div>
